/*
* @requires  ../util/websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function ZXQ3Websocket(param,m,callback) {
        this.host="ws://127.0.0.1:18212/zxq3";
        this.websocket=$m.createWebSocketWrapper(param,this.host);
        this.setEventCallback(m,callback);
        this.websocket.connect(param);
    }

    ZXQ3Websocket.prototype.setEventCallback=function(m,callback){
        this.middlewareObj=m;
        this.websocket.setEventCallback(m,callback);
    };

    ZXQ3Websocket.prototype.pdfSign=function (param) {
        var name="pdfSign";
        var that=this;

        var p={};
        $m.util.setAttrsDefault(p,param,["signType","signFlag","fpTimes","signRecord"],[3,0,1,false]);
        $m.util.setAttrs(p,param,[
            "pdfFileIn","pdfFileOut","pdfUrlDownload","pdfUrlUpload","pdfName",
            "signType","signFlag","fpTimes","page","pageRange","pos","signRecord"
        ]);

        this.websocket.sendMessage({
            fun: 'PdfSign',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, {
                    signRecord: json.signRecord
                });
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.openUrl=function (param) {
        var name="openUrl";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["url"]);

        this.websocket.sendMessage({
            fun: 'OpenUrl',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.webSign=function (param) {
        var name="webSign";
        var that=this;

        var p={};
        $m.util.setAttrsDefault(p,param,["signType","fpTimes"],[3,1]);
        $m.util.setAttrs(p,param,["url","session","signType","fpTimes"]);

        this.websocket.sendMessage({
            fun: 'WebSign',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.startScreenShare=function(param){
        var name="startScreenShare";
        var that=this;

        var p={};

        this.websocket.sendMessage({
            fun: 'StartScreenShare',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.stopScreenShare=function (param) {
        var name="stopScreenShare";
        var that=this;

        var p={};

        this.websocket.sendMessage({
            fun: 'StopScreenShare',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.showUser=function (param) {
        var name="showUser";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["dept","num","name","image"]);

        this.websocket.sendMessage({
            fun: 'ShowUser',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.getSignImage=function (param) {
        var name="getSignImage";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["imageType","size"]);

        this.websocket.sendMessage({
            fun: 'GetSignImage',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.image);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.readIDCard=function (param) {
        var name="readIDCard";
        var that=this;

        var p={};

        this.websocket.sendMessage({
            fun: 'ReadIDCard',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.info);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.compareManAndIDCard=function (param) {
        var name="compareManAndIDCard";
        var that=this;

        var p={};

        this.websocket.sendMessage({
            fun: 'CompareManAndIDCard',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, {
                    info: json.info,
                    errorCode: json.errorCode,
                    score: json.score,
                    screenImage: json.screenImage,
                });
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.takePicture=function (param) {
        var name="takePicture";
        var that=this;

        var p={};

        this.websocket.sendMessage({
            fun: 'TakePicture',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.image);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.recordSound=function (param) {
        var name="recordSound";
        var that=this;

        var p={};

        this.websocket.sendMessage({
            fun: 'RecordSound',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.sound);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.sendData=function (param) {
        var name="sendData";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["data"]);

        this.websocket.sendMessage({
            fun: 'SendData',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, JSON.parse(json.data));
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.multiPdfSign=function (param) {
        var name="multiPdfSign";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["filesIn","filesOut"]);

        this.websocket.sendMessage({
            fun: 'MultiPdfSign',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, {
                    isSign: json.isSign
                });
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.updateGradeInfo=function (param) {
        var name="updateGradeInfo";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["obj"]);

        this.websocket.sendMessage({
            fun: 'UpdateGradeInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.getGrade=function (param) {
        var name="getGrade";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["obj","name","id","image"]);

        this.websocket.sendMessage({
            fun: 'GetGrade',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.gradeData);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.getDeviceInfo=function (param) {
        var name="getDeviceInfo";
        var that=this;

        var p={};

        this.websocket.sendMessage({
            fun: 'GetDeviceInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.deviceInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.startActivity=function (param) {
        var name="startActivity";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["name"]);

        this.websocket.sendMessage({
            fun: 'StartActivity',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.getSecret=function (param) {
        var name="getSecret";
        var that=this;

        var p={};

        this.websocket.sendMessage({
            fun: 'GetSecret',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.secret);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    ZXQ3Websocket.prototype.close=function () {
        this.websocket.close()
    };

    $m.ZXQ3Websocket=ZXQ3Websocket;
})(HebcaMiddleware);
